import { render } from "./HeroiconsOutlineClipboardCheck.vue?vue&type=template&id=094ea8c4"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineClipboardCheck.vue"]])

export default __exports__